import { createSlice } from "@reduxjs/toolkit";

const InitialValue = {
  showPreloader: false,
};

const ActivePageSlice = createSlice({
  name: "ActivePageSlice",
  initialState: InitialValue,
  reducers: {
    setShowPreloader: (state, action) => {
      state.showPreloader = action.payload;
    },
  },
});

export const { setShowPreloader } = ActivePageSlice.actions;
export default ActivePageSlice.reducer;
